import { useState } from "react";
import { notification } from "antd";
import { TfsSrpYearRateIndexComponent } from "../components/tfsSrpYearRates/TfsSrpYearRateIndexComponent";
import { useFetchTfsSrpYearRates } from "../hooks/tfsSrpYearRates/useFetchTfsSrpYearRates";
import { useCreateTfsSrpYearRate } from "../hooks/tfsSrpYearRates/useCreateTfsSrpYearRate";
import { useUpdateTfsSrpYearRate } from "../hooks/tfsSrpYearRates/useUpdateTfsSrpYearRate";

export const TfsSrpYearRatesPage = () => {
  const [tableMeta, setTableMeta] = useState<{
    page: number;
    limit: number;
    query_search_value?: string;
  }>({
    page: 1,
    limit: 10,
  });
  const [searchText, setSearchText] = useState("");

  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [selectedRowKey, setSelectedRowKey] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  const tfsSrpYearRatesList = useFetchTfsSrpYearRates(tableMeta);
  const createTfsSrpYearRateData = useCreateTfsSrpYearRate;
  const updateTfsSrpYearRateData = useUpdateTfsSrpYearRate;

  const onPaginationChange = (page: any) => {
    setTableMeta({ ...tableMeta, page: page });
  };

  const onSearchChange = (value: string) => {
    setSearchText(value);
    setTableMeta({ ...tableMeta, query_search_value: value || undefined, page: 1 });
  };

  const onRefresh = () => {
    setTableMeta({ ...tableMeta });
  };

  const onSelectRow = (
    selectedRowIds: Array<number>,
    selectedRowInfos: Array<any>
  ) => {
    setSelectedRow(selectedRowInfos[0] ?? null);
    setSelectedRowKey(selectedRowIds[0] ?? 0);
  };

  const onClickCreate = () => {
    onSelectRow([], []); // clear selection so the modal opens in create mode
    setIsModalOpen(true);
  };

  const onClickUpdate = () => {
    setIsModalOpen(true);
  };

  const onCloseModal = () => {
    setIsModalOpen(false);
  };

  const onSaveModal = async (values: any) => {
    setModalLoading(true);
    try {
      const isUpdate = !!selectedRow;

      if (values.model_year === undefined || values.discount_percentage === undefined) {
        notification.error({
          message: "Model year and discount % are both required.",
        });
        return;
      }

      const isSuccess = isUpdate
        ? await updateTfsSrpYearRateData(selectedRow.tfs_srp_year_rate_id, values)
        : await createTfsSrpYearRateData(values);

      if (isSuccess) {
        setIsModalOpen(false);
        onSelectRow([], []);
        setTableMeta({ ...tableMeta, limit: 10 });
      }
    } finally {
      setModalLoading(false);
    }
  };

  const tfsSrpYearRateIndexProps = {
    isModalOpen,
    onClickCreate,
    onClickUpdate,
    onCloseModal,
    onSaveModal,
    modalLoading,
    tfsSrpYearRatesList,
    onPaginationChange,
    searchText,
    onSearchChange,
    onRefresh,
    onSelectRow,
    selectedRowKey,
    selectedRow,
  };

  return <TfsSrpYearRateIndexComponent {...tfsSrpYearRateIndexProps} />;
};
